export const paginationHeightRem = 5.6;
export const navbarHeightRem = 8;
export const verticalPageContentPaddingHeightRem = 4.8;
export const tabHeightRem = 6.5;
export const navigatorHeightRem = 8.1;
export const contentRatio = 10 / 12;
export const subscriptionAlertHeightRem = 9.6;
export const summaryProgressBarHeightInRem = 13.6;
